/*
 * @Author: mrzou
 * @Date: 2021-03-18 10:22:52
 * @LastEditors: mrzou
 * @LastEditTime: 2021-07-13 10:12:23
 * @Description: file content
 */
import Vue from 'vue'
import Mint from 'mint-ui'
import 'mint-ui/lib/style.css'

Vue.use(Mint)
